import { api } from '../../shared/api/client';
import { tokenStore } from '../../shared/api/tokens';

export type Role = 'user' | 'doctor' | 'admin';

export interface Credentials {
  email: string;
  password: string;
}

export interface ClinicBrief {
  id: string;
  name: string;
  city: string;
}

export interface CurrentUser {
  id: string;
  email: string;
  role: Role;
  fullName: string;
  phone: string;
  clinics: ClinicBrief[];
  createdAt?: string;
}

export interface AuthResult {
  access: string;
  refresh: string;
  user: CurrentUser;
}

export async function login(body: Credentials): Promise<AuthResult> {
  const { data } = await api.post<AuthResult>('/v1/auth/login', body);
  tokenStore.set(data.access, data.refresh);
  return data;
}

export async function logout(): Promise<void> {
  try {
    await api.post('/v1/auth/logout', { refresh: tokenStore.getRefresh() });
  } finally {
    tokenStore.clear();
  }
}

export async function getMe(): Promise<CurrentUser> {
  const { data } = await api.get<CurrentUser>('/v1/me');
  return data;
}

export async function updateMe(body: { fullName: string; phone: string }): Promise<CurrentUser> {
  const { data } = await api.patch<CurrentUser>('/v1/me', body);
  return data;
}

export async function setMyClinics(clinicIds: string[]): Promise<CurrentUser> {
  const { data } = await api.put<CurrentUser>('/v1/me/clinics', { clinicIds });
  return data;
}

/** Запрос письма со ссылкой на восстановление пароля. Ответ одинаковый
 *  независимо от того, зарегистрирован ли адрес. */
export async function forgotPassword(email: string): Promise<void> {
  await api.post('/v1/auth/password/forgot', { email });
}

/** Новый пароль по одноразовому токену из письма. Все сессии пользователя завершаются. */
export async function resetPassword(token: string, password: string): Promise<void> {
  await api.post('/v1/auth/password/reset', { token, password });
}
